import { Directive, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DestroyableBase } from 'osn-shared';

@Directive()
export class OsnComponentBase extends DestroyableBase {
  protected readonly translateService: TranslateService;
  constructor(injector: Injector) {
    super();
    this.translateService = injector.get(TranslateService);
  }

  public get currentLanguage(): 'en' | 'ar' {
    // @ts-ignore
    return this.translateService.currentLang;
  }
}
